const Required = (val) => {
    let valid = false;
    
    if (Array.isArray(val)) {
        valid = val.length > 0;
    } else if (typeof val === 'boolean') {
        valid = val;
    } else if (typeof val === 'string') {
        valid = val.length > 0;
    } else if (typeof val === 'number') {
        valid = val > 0;
    } else if (typeof val === 'object') {
        valid = Object.values(val).filter(v => !!val).length > 0;
    }

    return [
        valid,
        valid ? null : 'This field is required',
    ]
}

export default Required;